import { FC, useMemo } from "react";

import { useHasPermissions } from "@ryde/shared";

import { useRideSaveRoutePath, useStationRouteIndicator } from "./hooks";
import { SaveRouteIndicatorFragments } from "./parts";

export const RideHeaderSavedRouteIndicator: FC = () => {
  const { stationRouteId, isMlPathIgnored, ignoreMLPathReason } =
    useRideSaveRoutePath();
  const { isRouteExists, isRoutePaused } = useStationRouteIndicator();

  const { hasPermissions: hasUpdatePermission } = useHasPermissions({
    entity: "stationRoute",
    action: "update",
  });

  const isStationRouteIndicatorVisible = useMemo(() => {
    return Boolean(stationRouteId || hasUpdatePermission || isMlPathIgnored);
  }, [hasUpdatePermission, isMlPathIgnored, stationRouteId]);

  return (
    isStationRouteIndicatorVisible && (
      <SaveRouteIndicatorFragments
        isRouteDeleted={!isRouteExists}
        isRoutePaused={isRoutePaused}
        isMlPathIgnored={isMlPathIgnored}
        ignoreMLPathReason={ignoreMLPathReason}
        stationRouteId={stationRouteId}
      />
    )
  );
};
